
 import React, { Component } from 'react';
 import Header from '../header/newheader'
 import Footer from '../footer/newfooter';
 import {BASE} from '../api/api'
 import Axios from 'axios'
 import ReactHtmlParser from 'react-html-parser';

 
 class ContactUs extends Component {
     constructor(props) {
        super(props);
        this.state={
            contact: ''
            
        } 
       }
       topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
       componentWillMount(){
        console.log(new Date('Tue Apr 30 2019 23:59:59 GMT+0530').toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3"),'datee')

        Axios(BASE+'jsonapi/node/page?filter[title]=Contact Us', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
        .then((data) => {
            console.log(data.data.data[0].attributes.body.processed,'api')

            this.setState({
                contact:data.data.data[0].attributes.body.processed
            })
            this.topFunction();

        })
        .catch((err) => {
            console.log('not found')
        })
    }    
 
 render() {
     
     return (
     <div className='contact_rea'>
          <Header/>
          <div className="body contactpage listing">
    
    
    <div className="page-title">
      <div className="title-wrapper">
        <div className="container">
          <h1 className="heading">Contact Us</h1>
        </div>
      </div>
    </div>
    
    <div className="main-content">
      <div className="container basicpage">
        <div className="row">
        
        {ReactHtmlParser(this.state.contact?this.state.contact:'')}

        </div>
      </div>
    </div>
    
  
  </div>
  <Footer/> 
    </div>  
            )
    
    
}

}

export default ContactUs;